import React from 'react'
import styled from '@emotion/styled/macro'

const Heart = ({ active, className }) => (
  <HeartContainer width="25" height="24" active={active} className={className}>
    <path d="M12.4884 7.06219L10.3782 2.48726C10.2293 2.1644 9.77044 2.1644 9.62152 2.48726L7.51131 7.06219C7.45061 7.19378 7.32591 7.28438 7.18201 7.30144L2.17891 7.89464C1.82582 7.9365 1.68403 8.37291 1.94507 8.61432L5.64399 12.035C5.75038 12.1334 5.79801 12.28 5.76977 12.4221L4.78789 17.3636C4.7186 17.7124 5.08983 17.9821 5.40009 17.8084L9.79636 15.3476C9.92281 15.2768 10.0769 15.2768 10.2034 15.3476L14.5997 17.8084C14.9099 17.9821 15.2812 17.7124 15.2119 17.3636L14.23 12.4221C14.2017 12.28 14.2494 12.1334 14.3558 12.035L18.0547 8.61432C18.3157 8.37291 18.1739 7.9365 17.8208 7.89464L12.8177 7.30144C12.6738 7.28438 12.5491 7.19378 12.4884 7.06219Z" fill="#FF5B00"/>
  </HeartContainer>
)

const HeartContainer = styled('svg')`
  vertical-align: middle;

  path {
    fill: #ff5b00;
    stroke: #ff5b00;
    transition: 0.2s ease-out;
  }

  &:hover {
    path {
      fill: none;
      stroke: #e7e7e7;
    }
  }
`

export default Heart
